import e from "@dialpad/dialtone-tokens/layered/themes/tokens-136-colors.css?inline";
//#region themes/136.js
var t = { brand: {
	css: e,
	name: "136"
} };
//#endregion
export { t as default };
